import { useCallback, useEffect, useState } from "react";
import { RouteManager, RouterChangeHandler } from ".";

export type UseRouterReturn = ReturnType<typeof useRouter>;

export const useRouter = () => {
  const [, renderizer] = useState(Router.pathname);

  const handler: RouterChangeHandler = useCallback(({ href }) => {
    renderizer(href);
  }, []);

  Router.onRouteChange(handler);

  useEffect(() => {
    return () => Router.removeOnRouteChange(handler);
  }, []);

  return Router;
};

export const Router = new RouteManager();
